module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container--wide"
  }, [_c('h1', [_vm._v("Analysis")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.app.entries.length) ? _c('div', [_c('h2', [_vm._v("Hydrogen Fuelled Per Month")]), _vm._v(" "), _c('LineChart', {
    attrs: {
      "chartData": _vm.hydrogenFuelled,
      "options": _vm.chartOptionsH
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.app.user.vehicle_model === 'Symbio') ? _c('div', [_c('h2', [_vm._v("Electricity Charged Per Month")]), _vm._v(" "), _c('LineChart', {
    attrs: {
      "chartData": _vm.electricityFuelled,
      "options": _vm.chartOptionsE
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Cost Per Month")]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "chartData": _vm.cost,
      "options": _vm.chartOptionsC
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'History'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tView All Data\n\t\t\t")])], 1)], 1) : _c('div', [_c('h2', [_vm._v("You currently don't have any data to analyse.")]), _vm._v(" "), _c('p', [_vm._v("As you start to add entries to this app, we will show you the break down of cost and hydrogen fuelled over the your distance traveled.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tAdd entry\n\t\t\t")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7afe860a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Analysis.vue
// module id = 635
// module chunks = 1